import { render, staticRenderFns } from "./ScheduleAlternative.vue?vue&type=template&id=90443580&scoped=true&"
import script from "./ScheduleAlternative.vue?vue&type=script&lang=js&"
export * from "./ScheduleAlternative.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleAlternative.vue?vue&type=style&index=0&id=90443580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90443580",
  null
  
)

export default component.exports